<template>
	<div>
		<div
		 class="expect-job-detail expect-salary"
		 @click="showPopup"
		 :class="{'item-error': isError}"
		>
			<span
			 class="name-tip"
			 :class="{'title-tip': hasSelected, 'error': isError}"
			>期望薪资</span>
			<span
			 v-show="hasSelected"
			 class="selected-text"
			>{{selectedText}}</span>
		</div>
		<popup v-model="showBox">
			<div class="popup-box">
				<div class="popup-title">
					<span class="title">请选择您期望的薪资范围</span>
					<span
					 class="btn"
					 @click="hidePopup"
					>确定</span>
				</div>
				<select-scroll
				 :dataList="salaryList"
				 :selectedIndex="selectedIndex"
				 :show="showBox"
				 @scrollEnd="scrollEnd"
				></select-scroll>
			</div>
		</popup>
	</div>
</template>
<script>
import { Popup } from "@58fe/v5";
import selectScroll from "../../common/selectScroll";
import config from "../../../util/config";
import * as types from "../../../store/mutation-types";
import { mapGetters } from "vuex";

export default {
	components: {
		Popup,
		selectScroll
	},
	data() {
		return {
			showBox: false,
			salaryList: ["", ""].concat(config.salaryList).concat(["", ""]),
			selectedIndex: 0,
			selectedText: "",
			hasSelected: false,
			isError: false
		};
	},
	computed: {
		...mapGetters(["salary", "pagetypeLog"])
	},
	watch: {
		salary(val) {
			this.hasSelected = true;
			this.selectedIndex = val;
			this.selectedText = config.salaryList[val];
		}
	},
	created() {
		if (this.salary !== "") {
			this.hasSelected = true;
			this.selectedIndex = this.salary;
			this.selectedText = config.salaryList[this.salary];
		}
	},
	methods: {
		hidePopup() {
			this.showBox = false;
		},
		showPopup() {
			this.showBox = true;
			// 如果未选择，则选择默认
			if (this.selectedText === "") {
				this.scrollEnd(this.selectedIndex);
			}
			window.clickLog &&
				window.clickLog("from=jl_targetsalaryclick" + this.pagetypeLog);
		},
		scrollEnd(index) {
			this.selectedIndex = index;
			this.hasSelected = true;
			this.selectedText = config.salaryList[index];
			this.isError = false;

			//  检查是否已填写完整所有必填项
			this.$store.commit(types.CHECK_EXPECTIONINFO, {
				key: "salary",
				value: index,
				state: true
			});
		},
		checkNull() {
			this.isError = true;
			window.clickLog &&
				window.clickLog("from=jl_targetsalarymiss" + this.pagetypeLog);
		}
	}
};
</script>
<style lang="scss" scoped>
@import "../../../assets/style/public.scss";
.popup-box {
	height: px2rem(576px);
	background: #ffffff;
}
</style>


// WEBPACK FOOTER //
// salaryIntention.vue?688d732c